import { render, staticRenderFns } from "./modalCrearPedidoCliente.vue?vue&type=template&id=5747bcfa&scoped=true&"
import script from "./modalCrearPedidoCliente.vue?vue&type=script&lang=js&"
export * from "./modalCrearPedidoCliente.vue?vue&type=script&lang=js&"
import style0 from "./modalCrearPedidoCliente.vue?vue&type=style&index=0&id=5747bcfa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5747bcfa",
  null
  
)

export default component.exports